import { render } from "./Role.html?vue&type=template&id=1c88284e&scoped=true&ts=true"
import script from "./Role.ts?vue&type=script&lang=ts"
export * from "./Role.ts?vue&type=script&lang=ts"

import "./Role.css?vue&type=style&index=0&id=1c88284e&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c88284e"]])

export default __exports__